import React from "react";
import { Link } from "react-router-dom";

/**
 * Render a notification's text with hyperlinked actor + entity substrings.
 *
 * Backend now persists an optional `tokens` array on each notification with the
 * structured intent of the message. When present we render each token:
 *   - kind="actor"  → <Link to={href}> styled like a profile link
 *   - kind="entity" → <Link to={href}> styled like an entity link
 *   - kind="text"   → plain span
 *
 * When `tokens` is missing (legacy notifications already in the DB) we fall
 * back to rendering the existing `n.text` field as plain text — no regression.
 *
 * `stopPropagation` on each Link prevents the row click handler in the parent
 * (ActivityFeed / Dashboard) from also firing, so the user can independently
 * click the actor / entity / or the rest of the row.
 */
export function NotificationText({ n }) {
  const tokens = Array.isArray(n?.tokens) ? n.tokens : null;
  if (!tokens || tokens.length === 0) {
    return <>{n?.text || ""}</>;
  }
  return (
    <>
      {tokens.map((t, i) => {
        if (t.kind === "actor" || t.kind === "entity") {
          if (!t.href) return <span key={i}>{t.label}</span>;
          return (
            <Link
              key={i}
              to={t.href}
              onClick={(e) => e.stopPropagation()}
              className="font-[600] text-foreground hover:text-primary hover:underline"
              data-testid={t.kind === "actor" ? "notif-actor-link" : "notif-entity-link"}
            >
              {t.label}
            </Link>
          );
        }
        // kind === "text" (or any unknown kind — render the literal value).
        return <span key={i}>{t.value}</span>;
      })}
    </>
  );
}

export default NotificationText;
